export const activitySettings = {
  title: 'Configuración de la actividad',
  
  // Informations du commerce
  businessInfo: {
    title: 'Información del negocio',
    businessId: 'Identificador del negocio',
    businessName: 'Nombre del negocio'
  },

  // Logo
  logo: {
    title: 'Logo',
    upload: 'Subir logo',
    preview: 'Vista previa del logo'
  },

  // Paramètres généraux
  generalSettings: {
    title: 'Configuración general',
    currency: {
      label: 'Moneda',
      options: {
        EUR: 'EUR (€)',
        USD: 'USD ($)',
        GBP: 'GBP (£)',
        MAD: 'MAD (د.م.)'
      }
    },
    language: {
      label: 'Idioma predeterminado',
      options: {
        fr: 'Français',
        ar: 'العربية',
        es: 'Español'
      }
    }
  },

  // Numérotation des tickets
  ticketNumbering: {
    title: 'Numeración de tickets',
    type: {
      label: 'Tipo de numeración',
      options: {
        monthly: 'Mensual',
        yearly: 'Anual',
        continuous: 'Continuo'
      }
    },
    prefix: {
      label: 'Prefijo',
      placeholder: 'ej: TKT'
    },
    suffix: {
      label: 'Sufijo',
      placeholder: 'ej: -2024'
    },
    startNumber: {
      label: 'Número inicial'
    }
  },

  // Messages
  messages: {
    saveSuccess: '¡Configuración guardada con éxito!',
    saveError: 'Error al guardar la configuración',
    loadError: 'Error al cargar la configuración',
    saving: 'Guardando...',
    save: 'Guardar cambios'
  }
}; 